import { gql } from "@apollo/client";

export const BULK_CREATE_ADJUSTMENT_LOGS = gql`
    mutation bulkCreateInventoryAdjustmentLogs($dateAndTime: DateTime!, $logs: [InventoryAdjustmentLogInputType]!) {
        bulkCreateInventoryAdjustmentLogs(dateAndTime: $dateAndTime, logs: $logs) {
            inventoryAdjustmentLogs {
                id
            }
        }
    }
`